import { render, staticRenderFns } from "./ex-login.vue?vue&type=template&id=7324632c&scoped=true&"
import script from "./ex-login.vue?vue&type=script&lang=js&"
export * from "./ex-login.vue?vue&type=script&lang=js&"
import style0 from "./ex-login.vue?vue&type=style&index=0&id=7324632c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7324632c",
  null
  
)

export default component.exports